// All of the requested modules are loaded behind enumerable getters.
const map = Object.defineProperties({}, {
  "./+not-found.tsx": { enumerable: true, get() { return require("/Users/pasqui/Sites/also-there/app/+not-found.tsx"); } },
  "./_layout.tsx": { enumerable: true, get() { return require("/Users/pasqui/Sites/also-there/app/_layout.tsx"); } },
  "./_layout.web.tsx": { enumerable: true, get() { return require("/Users/pasqui/Sites/also-there/app/_layout.web.tsx"); } },
  "./admin.tsx": { enumerable: true, get() { return require("/Users/pasqui/Sites/also-there/app/admin.tsx"); } },
  "./benchmarking.tsx": { enumerable: true, get() { return require("/Users/pasqui/Sites/also-there/app/benchmarking.tsx"); } },
  "./compare.tsx": { enumerable: true, get() { return require("/Users/pasqui/Sites/also-there/app/compare.tsx"); } },
  "./faq.tsx": { enumerable: true, get() { return require("/Users/pasqui/Sites/also-there/app/faq.tsx"); } },
  "./forgot-password.tsx": { enumerable: true, get() { return require("/Users/pasqui/Sites/also-there/app/forgot-password.tsx"); } },
  "./index.tsx": { enumerable: true, get() { return require("/Users/pasqui/Sites/also-there/app/index.tsx"); } },
});

function metroContext(request) {
    return map[request];
}

// Return the keys that can be resolved.
metroContext.keys = function metroContextKeys() {
  return Object.keys(map);
};

// Return the module identifier for a user request.
metroContext.resolve = function metroContextResolve(request) {
  throw new Error('Unimplemented Metro module context functionality');
}

module.exports = metroContext;